export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/aadf7e204ac3ecb8628e2b693a3c4a40.svg";